export default __webpack_public_path__ + "static/icon-rows-d55e71349936a4ab61f2f491c304a77e.svg";